import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseRequestDetail } from "src/models/Products/PurchaseRequest.models";

interface serieDetailstate {
  purchaseRequestDetails: IPurchaseRequestDetail[];
  purchaseRequestTemporalDetails: IPurchaseRequestDetail[];
  purchaseRequestDetailToEdit: IPurchaseRequestDetail | null;
  purchaseRequestTemporalDetailToEdit: IPurchaseRequestDetail | null;
}

const initialState: serieDetailstate = {
  purchaseRequestDetails: [],
  purchaseRequestTemporalDetails: [],
  purchaseRequestDetailToEdit: null,
  purchaseRequestTemporalDetailToEdit: null,
};

const purchaseRequestDetailSlice = createSlice({
  name: "PurchaseRequestDetail",
  initialState,
  reducers: {
    setPurchaseRequestDetailList: (state, action: PayloadAction<IPurchaseRequestDetail[]>) => {
      state.purchaseRequestDetails = action.payload;
    },
    setPurchaseRequestTemporalDetailList: (state, action: PayloadAction<IPurchaseRequestDetail[]>) => {
      state.purchaseRequestTemporalDetails = action.payload;
    },
    concatListPurchaseRequestDetail: (
      state: serieDetailstate,
      action: PayloadAction<IPurchaseRequestDetail[]>
    ) => {
      state.purchaseRequestDetails = [...state.purchaseRequestDetails.concat(action.payload)];
    },
    concatListPurchaseRequestTemporalDetail: (
      state: serieDetailstate,
      action: PayloadAction<IPurchaseRequestDetail[]>
    ) => {
      state.purchaseRequestTemporalDetails = [...state.purchaseRequestTemporalDetails.concat(action.payload)];
    },
    setPurchaseRequestDetailToEdit: (
      state,
      action: PayloadAction<IPurchaseRequestDetail | null>
    ) => {
      state.purchaseRequestDetailToEdit = action.payload;
    },
    setPurchaseRequestTemporalDetailToEdit: (
      state,
      action: PayloadAction<IPurchaseRequestDetail | null>
    ) => {
      state.purchaseRequestTemporalDetailToEdit = action.payload;
    },
    addPurchaseRequestDetail: (state, action: PayloadAction<IPurchaseRequestDetail>) => {
      state.purchaseRequestDetails.push(action.payload);
    },
    addPurchaseRequestTemporalDetail: (state, action: PayloadAction<IPurchaseRequestDetail>) => {
      state.purchaseRequestTemporalDetails.push(action.payload);
    },
    updatePurchaseRequestDetail: (state, action: PayloadAction<IPurchaseRequestDetail>) => {
      let itemIndex = state.purchaseRequestDetails.findIndex(
        item => item.purchaseRequestDetailId === action.payload.purchaseRequestDetailId
      );
      if (itemIndex !== -1) state.purchaseRequestDetails[itemIndex] = action.payload;
    },
    updatePurchaseRequestTemporalDetail: (state, action: PayloadAction<IPurchaseRequestDetail>) => {
      let itemIndex = state.purchaseRequestTemporalDetails.findIndex(
        item => item.purchaseRequestDetailId === action.payload.purchaseRequestDetailId
      );
      if (itemIndex !== -1) state.purchaseRequestTemporalDetails[itemIndex] = action.payload;
    },
    deletePurchaseRequestDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.purchaseRequestDetails.filter(
        item => item.purchaseRequestDetailId !== action.payload
      );
      state.purchaseRequestDetails = newArray;
    },
    deletePurchaseRequestTemporalDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.purchaseRequestTemporalDetails.filter(
        item => item.purchaseRequestDetailId !== action.payload
      );
      state.purchaseRequestTemporalDetails = newArray;
    },
  },
});

export const {
  setPurchaseRequestDetailList,
  concatListPurchaseRequestDetail,
  setPurchaseRequestDetailToEdit,
  addPurchaseRequestDetail,
  updatePurchaseRequestDetail,
  deletePurchaseRequestDetail,
  setPurchaseRequestTemporalDetailList,
  concatListPurchaseRequestTemporalDetail,
  setPurchaseRequestTemporalDetailToEdit,
  addPurchaseRequestTemporalDetail,
  updatePurchaseRequestTemporalDetail,
  deletePurchaseRequestTemporalDetail,
} = purchaseRequestDetailSlice.actions;

export default purchaseRequestDetailSlice.reducer;
